<template>

  <div class="container">

    <div class="row">

      <div class="col-12 offset-0 col-md-6 offset-md-3 text-center">

        <h4 class="mb-4 menu-dark font-weight-light">What is ChipIn&trade;?</h4>
          
        <b-alert v-if="error" show variant="danger" class="mb-4 text-left">
          <h5 class="alert-heading">Error</h5>
          <p class="alert-danger mb-0">
            {{ error }}
          </p>
        </b-alert>

        <p>At Trackd we’ve set out to create groundbreaking tools and opportunities to benefit our artist community.</p>
        <p> We believe in fair pay, based on talent, not market share. We’re giving our artists the funds they deserve and the fans, the music they need to hear. </p>
        <p>ChipIn is our revolutionary, built-in artist donation tool. </p>
        <p>With ChipIn, your fans can directly support you. Trackd does not take any share of your donations. Stripe, our banking partner charges a small transaction fee, you can read more about it here.</p>

        <small>By registering your account, you agree to our <a href="https://www.trackdmusic.com/terms/chipin/">Services Agreement</a> and the <a href="https://stripe.com/gb/connect-account/legal">Stripe Connected Account Agreement.</a></small>

        <br>
        
        <b-button variant="success" class="mt-3" @click="register">Setup Here</b-button>

      </div>

    </div>

  </div>

</template>

<script>

import axios from 'axios';

export default {
  name: 'Register',
  data() {
    return  {
      error: null
    }
  },
  methods: {
    loadData () {
      let token = this.$route.query.jwt;

      if (token) {

        axios.get('/chipin/account/auth/?jwt=' + token)
            .then(res => {
              res.status
              localStorage.setItem('accessToken', token)
              this.$store.dispatch('storeToken', token)
              //this.$router.replace('/')
            })
            .catch(error => {
              this.name = 'Sorry something went wrong!';
              console.log(error)
            });

      } else {
        this.name = 'Sorry something went wrong!';
      }

    },
    register() {

      let headers = {
        'Authorization': 'JWT ' + this.$route.query.jwt
      }

      this.error = null;

      axios.post('/chipin/api/register-account/', {}, {'headers': headers}).then(res => {
        
        window.location = res.data.url

      }).catch(error => {
        console.log(error.response.data)
        console.log('here')
        this.error = error.response.data.errors[0];
      });
    }
  },
  beforeMount(){
      this.loadData()
   },
}
</script>
